<ion-tabs>
  <ion-tab-bar color="secondary" slot="bottom">
    <ion-tab-button tab="dashboard">
      <fa-icon [icon]="['fal', 'ywc']" size="2x" [fixedWidth]="true"></fa-icon>
      <ion-label>{{ 'Start' | translate }}</ion-label>
    </ion-tab-button>
    <!--
    <ion-tab-button tab="explore">
      <fa-icon [icon]="['fal', 'user-check']" size="2x" [fixedWidth]="true"></fa-icon>
      <ion-label>{{ 'Vorschläge' | translate }}</ion-label>
    </ion-tab-button>
-->

    <ion-tab-button tab="chats">
      <ion-badge color="primary" mode="ios" class="w-3 h-3 rounded-full block" *ngIf="(hasUnreadMessages$ | async)"></ion-badge>
      <fa-icon [icon]="['fal', 'comments']" size="2x"></fa-icon>
      <ion-label>{{ 'Chats' | translate }}</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="groups">
      <fa-icon [icon]="['fal', 'users']" size="2x" [fixedWidth]="true"></fa-icon>
      <ion-label>{{ 'Gruppen' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="profile">
      <ion-badge color="primary" mode="ios" class="w-5 h-5 text-xs font-bold rounded-full p-0 flex justify-center items-center" *ngIf="(notifications$ | async)?.length">
        {{ (notifications$ | async)?.length }}
      </ion-badge>
      <fa-icon [icon]="['fal', 'user-circle']" size="2x" [fixedWidth]="true"></fa-icon>
      <ion-label>{{ 'Profil' | translate }}</ion-label>
    </ion-tab-button>
    <!--
    <ion-tab-button tab="more">
      <fa-icon [icon]="['fal', 'ellipsis-h']" size="2x" [fixedWidth]="true"></fa-icon>
      <ion-label>{{ 'Mehr' | translate }}</ion-label>
    </ion-tab-button>
     -->
  </ion-tab-bar>
</ion-tabs>
